<template>
    <ul class="pagination" role="menubar" aria-label="Pagination">
        <li :class="['page-item', atStart && 'disabled']"><button type="button" class="page-link" aria-label="Go to first page" :disabled="disabled || atStart" @click="select(1)">&laquo;</button></li>
        <li :class="['page-item', atStart && 'disabled']"><button type="button" class="page-link" aria-label="Go to previous page" :disabled="disabled || atStart" @click="select(currentPage - 1)">&lsaquo;</button></li>
        <li v-if="pages[0] > 1" class="page-item disabled"><span class="page-link">…</span></li>
        <li v-for="page in pages" :key="page" :class="['page-item', page === currentPage && 'active']">
            <button type="button" class="page-link" :aria-label="`Go to page ${page}`" :aria-current="page === currentPage ? 'page' : null" :disabled="disabled" @click="select(page)">{{ page }}</button>
        </li>
        <li v-if="pages[pages.length - 1] < pageCount" class="page-item disabled"><span class="page-link">…</span></li>
        <li :class="['page-item', atEnd && 'disabled']"><button type="button" class="page-link" aria-label="Go to next page" :disabled="disabled || atEnd" @click="select(currentPage + 1)">&rsaquo;</button></li>
        <li :class="['page-item', atEnd && 'disabled']"><button type="button" class="page-link" aria-label="Go to last page" :disabled="disabled || atEnd" @click="select(pageCount)">&raquo;</button></li>
    </ul>
</template>
<script>
import { emitModel } from "./model";
export default {
    name: "SbPagination",
    emits: ["update:modelValue", "change", "page-click"],
    props: {
        modelValue: { default: undefined },
        totalRows: { type: [Number, String], default: 0 },
        perPage: { type: [Number, String], default: 20 },
        limit: { type: [Number, String], default: 5 },
        disabled: { type: Boolean, default: false },
    },
    data() { return { localPage: this.sanitize(this.modelValue ?? 1) }; },
    computed: {
        pageCount() { return Math.max(1, Math.ceil(Math.max(0, Number(this.totalRows) || 0) / Math.max(1, Number(this.perPage) || 1))); },
        currentPage() { return Math.max(1, Math.min(this.localPage, this.pageCount)); },
        atStart() { return this.currentPage <= 1; },
        atEnd() { return this.currentPage >= this.pageCount; },
        pages() {
            const limit = Math.max(1, Number(this.limit) || 5);
            let start = Math.max(1, this.currentPage - Math.floor(limit / 2));
            let end = Math.min(this.pageCount, start + limit - 1);
            start = Math.max(1, end - limit + 1);
            return Array.from({ length: end - start + 1 }, (_, index) => start + index);
        },
    },
    watch: {
        modelValue(value) { if (value !== undefined) { this.localPage = this.sanitize(value); } },
        perPage() { this.select(1); },
        pageCount() { if (this.localPage > this.pageCount) { this.select(1); } },
    },
    methods: {
        sanitize(value) { return Math.max(1, Number.parseInt(value, 10) || 1); },
        select(page) {
            if (this.disabled) { return; }
            const nextPage = Math.max(1, Math.min(this.sanitize(page), this.pageCount));
            if (nextPage === this.currentPage) { return; }
            const event = { page: nextPage, prevented: false, preventDefault() { this.prevented = true; } };
            this.$emit("page-click", event, nextPage);
            if (event.prevented) { return; }
            this.localPage = nextPage;
            emitModel(this, nextPage);
            this.$emit("change", nextPage);
        },
    },
};
</script>
